import React, { useState } from 'react';
import BasicModal from '../../../components/BasicModal';
import { translate } from '../../../services/translate';
import FormInput from '../../../components/FormInput';
import { cameraService } from '../../../services/central-api/cameras';
import Toast from 'react-native-toast-message';

interface ModalProps {
    setModalVisible: React.Dispatch<React.SetStateAction<boolean>>;
    setCreatePointOfInterest: React.Dispatch<React.SetStateAction<boolean>>;
    isModalVisible: boolean;
    latitude: string;
    longitude: string;
    onClose: () => void;
}

export default function PointOfInterestModal({ isModalVisible, setModalVisible, setCreatePointOfInterest, latitude, longitude, onClose }: ModalProps) {
    const [name, setName] = useState<string>('');
    const [description, setDescription] = useState<string>('');

    function isFormValid() {
        return name !== '';
    }

    return (
        <BasicModal
            isModalVisible={isModalVisible}
            setModalVisible={setModalVisible}
            title={translate('pointOfInterest')}
            width='small'
            mobileHeight='fit'
            cancelButton={{}}
            primaryButton={{
                text: translate('save'),
                disabled: !isFormValid(),
                onClick: async () => {
                    setCreatePointOfInterest(false);
                    try {
                        await cameraService.createPointOfInterest({
                            name,
                            description,
                            latitude: Number(latitude),
                            longitude: Number(longitude)
                        });
                        Toast.show({
                            type: 'sentinelxSuccess',
                            text1: translate('ActionSuccessfully'),
                        });
                        onClose();
                    } catch (error) {
                        Toast.show({
                            type: 'sentinelxError',
                            text1: translate('unexpectedError'),
                        });
                        return false;
                    } finally {
                        setName('');
                        setDescription('');
                    }
                }
            }}
        >
            <FormInput
                label={translate('name')}
                invalid={() => false}
                value={name}
                onChangeText={setName}
            />
            <FormInput
                numberOfLines={5}
                multiline={true}
                label={translate('description')}
                invalid={() => false}
                value={description}
                onChangeText={setDescription} />
        </BasicModal>
    );
}
